import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000'
const FIXED_TOKEN = import.meta.env.VITE_FIXED_TOKEN || 'projetoize-admin-token-2024-secure-key'

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Adiciona token de autenticação fixo para rotas públicas (signup, checkout)
api.interceptors.request.use((config) => {
  // Adiciona token apenas para rotas que precisam (tenants, payments)
  // Não adiciona para /auth/login pois é uma rota pública
  if ((config.url?.includes('/tenants') || config.url?.includes('/payments')) && !config.url?.includes('/auth/login')) {
    config.headers.Authorization = `Bearer ${FIXED_TOKEN}`
  }
  return config
})

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Erro da API
      const message = error.response.data?.message || 'Erro ao processar requisição'
      return Promise.reject(new Error(message))
    } else if (error.request) {
      // Erro de rede
      return Promise.reject(new Error('Erro de conexão. Verifique sua internet.'))
    } else {
      // Outro erro
      return Promise.reject(error)
    }
  }
)

